import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import ImmutablePropTypes from 'react-immutable-proptypes'
import ImmutablePureComponent from 'react-immutable-pure-component'
import { getOrderedLists } from '../../selectors'
import { fetchLists } from '../../actions/lists'
import PanelLayout from './panel_layout'
import List from '../list'
import capitalize from 'lodash/capitalize'

class ListsSinglePanel extends ImmutablePureComponent {

  state = {
    fetched: false,
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.shouldLoad && !prevState.fetched) {
      return { fetched: true }
    }

    return null
  }

  componentDidMount() {
    if (!this.props.isLazy) {
      this.props.onFetchLists(this.props.type)
      this.setState({ fetched: true })
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (!prevState.fetched && this.state.fetched) {
      this.props.onFetchLists(this.props.type)
    }
  }

  render() {
    const { lists, listsListsBlock, type, noPanel } = this.props
    const { fetched } = this.state

    const maxCount = 12
    const isFetched = fetched || listsListsBlock.getIn([type, 'isFetched'], false)
    const isLoading = listsListsBlock.getIn([type, 'isLoading'], false)
    const count = !!lists ? lists.size : 0

    const listItems = !!lists && lists.sortBy(Math.random).slice(0, maxCount).map((list) => ({
      to: `/feeds/${list.get('id')}`,
      title: list.get('title'),
      icon: list.get('visibility') === 'private' ? 'lock' : 'globe',
    }))

    const title = capitalize(`${type} Feeds`)

    return (
      <PanelLayout
        title={title}
        noPadding
        noPanel={noPanel}
        headerButtonTitle='Show all'
        headerButtonTo='/feeds'
        footerButtonTitle={count > maxCount ? 'Show all' : undefined}
        footerButtonTo={count > maxCount ? '/feeds' : undefined}
      >
        <div className={[_s.d, _s.w100PC, _s.boxShadowNone].join(' ')}>
          {((isLoading && !isFetched) || listItems.size > 0) &&
          <List
            scrollKey='lists_sidebar_panel'
            items={listItems}
            isLoading={isLoading}
            showLoading={(lists.size === 0 && !isFetched) || isLoading}
          />
          }
        </div>
      </PanelLayout>
    )
  }

}

const mapStateToProps = (state, { type }) => ({
  listsListsBlock: state.getIn(['lists_lists']),
  lists: getOrderedLists(state, type),
})

const mapDispatchToProps = (dispatch) => ({
  onFetchLists: (type) => dispatch(fetchLists(type)),
})

ListsSinglePanel.propTypes = {
  onFetchLists: PropTypes.func.isRequired,
  lists: ImmutablePropTypes.list,
  isLazy: PropTypes.bool,
  type: PropTypes.string,
  shouldLoad: PropTypes.bool,
  onOpenListCreateModal: PropTypes.func.isRequired,
}

export default connect(mapStateToProps, mapDispatchToProps)(ListsSinglePanel)
